module.exports = __webpack_public_path__ + "static/img/mobile_gzh.b0dd45a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile_gzh.jpg
// module id = xKfs
// module chunks = 0